import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { PillarArticle, articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { buildHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { SHOPIFY_B2B_COPY } from "@/lib/competitive-gap-resource-content";

const PATH = "/es/recursos/shopify-b2b";
const ALT = "/resources/shopify-b2b";
const COPY = SHOPIFY_B2B_COPY.es;
const PUBLISHED = "2026-08-24T18:45:00.000Z";
const MODIFIED = "2026-08-24T18:45:00.000Z";

export const Route = createFileRoute("/es/recursos/shopify-b2b")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: COPY.metaTitle,
    description: COPY.description,
    path: PATH,
    altPath: ALT,
    type: "article",
    author: "Samuel Noriega",
    articleAuthor: "Samuel Noriega",
    articleSection: "Shopify B2B",
    publishedTime: PUBLISHED,
    modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({
        title: COPY.title,
        description: COPY.description,
        path: PATH,
        publishedTime: PUBLISHED,
        modifiedTime: MODIFIED,
        section: "Shopify B2B",
      }),
      breadcrumbJsonLd([
        { name: "Inicio", path: "/es" },
        { name: "Recursos", path: "/es/recursos" },
        { name: "Shopify B2B", path: PATH },
      ]),
      faqJsonLd(COPY.faqs),
    ],
  }),
  component: () => (
    <SiteShell>
      <PillarArticle
        locale="es"
        path={PATH}
        eyebrow={COPY.eyebrow}
        title={COPY.title}
        intro={COPY.intro}
        updated={COPY.updated}
        readingMinutes={COPY.readingMinutes}
        hubHref="/es/recursos"
        hubLabel="Ver todos los recursos"
        sections={COPY.sections}
        faqs={COPY.faqs}
        related={COPY.related}
        midCTA={COPY.midCTA}
        finalCTA={COPY.finalCTA}
        publishedTime={PUBLISHED}
        modifiedTime={MODIFIED}
        guideLabelEs="Guía pilar"
      />
    </SiteShell>
  ),
});
